/**
 * Header Component
 * Displays app branding, current date/time, theme switcher, and settings trigger.
 */
import React, { useState, useEffect } from 'react';
import { Sun, Moon, Settings, LayoutGrid, Calendar, Clock } from 'lucide-react';
import '../Auth.css';

export function Header({
  isDarkMode,
  setIsDarkMode,
  onOpenSettings,
}) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 30000); // Update every 30s to conserve energy
    return () => clearInterval(timer);
  }, []);

  const weekday = currentTime.toLocaleString('vi-VN', { weekday: 'long' });
  const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
  const dateStr = currentTime.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const timeStr = currentTime.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit', hour12: true });

  return (
    <header className="header">
      <div className="header-brand-block">
        <div className="header-title-row">
          <div className="header-logo-badge" aria-hidden="true">
            <LayoutGrid size={15} />
          </div>
          <h1 className="header-title">Time Management Matrix</h1>
        </div>
        <div className="header-datetime" aria-label={`Thời gian hiện tại: ${capitalizedWeekday}, ${dateStr} lúc ${timeStr}`}>
          <span className="datetime-item">
            <Calendar size={12} className="datetime-icon" aria-hidden="true" />
            <span>{capitalizedWeekday}, {dateStr}</span>
          </span>
          <span className="datetime-dot" aria-hidden="true">•</span>
          <span className="datetime-item">
            <Clock size={12} className="datetime-icon" aria-hidden="true" />
            <span>{timeStr}</span>
          </span>
        </div>
      </div>

      <div className="header-right">
        <button
          type="button"
          className="header-action-btn theme-toggle-btn"
          onClick={() => setIsDarkMode(!isDarkMode)}
          title={isDarkMode ? "Chuyển sang giao diện Sáng" : "Chuyển sang giao diện Tối"}
          aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
        >
          {isDarkMode ? <Sun size={17} className="theme-icon sun" /> : <Moon size={17} className="theme-icon moon" />}
        </button>

        <button
          type="button"
          className="header-action-btn settings-header-btn"
          onClick={onOpenSettings}
          title="Cài đặt ứng dụng"
          aria-label="Cài đặt ứng dụng"
        >
          <Settings size={17} className="settings-icon" />
        </button>
      </div>
    </header>
  );
}
